import React, { FC } from 'react';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { permissions } from 'utils/permission';
import { LinkedClinic, LinkedUser } from 'models/order';
import { OrderInputType } from 'models/order-input/shared';
import SupplierOrder from './supplier-order.component';
import { SupplierOrderProvider } from './supplier-order-context';
import { SupplierOrderInput } from 'models/order-input/supplier-order';
import { Organization } from 'models/organization';

const CreateSupplierOrder: FC = () => {
    const currentOrg = currentOrgVar();

    const order = {
        inputType: OrderInputType.NEW,
        isWhiteLabeled: permissions.isWhiteLabeledOrganization(currentOrg),
        supplier: {} as Organization,
        customer: currentOrg,
        restorations: [],
        participants: {
            linkedDentists: [] as LinkedUser[],
            linkedClinics: [] as LinkedClinic[],
            customParticipantEmails: [] as string[],
        },
        comment: '',
        files: [],
        historicalComments: [],
        sample: { type: '', content: [], otherContent: '' },
        deliveryDetails: {
            date: new Date(),
            time: {
                hour: undefined,
                minute: undefined,
            },
            pickUpLocation: currentOrg,
            destination: currentOrg,
        },
    } as SupplierOrderInput;

    return (
        <SupplierOrderProvider initialOrder={order}>
            <SupplierOrder />
        </SupplierOrderProvider>
    );
};

export default CreateSupplierOrder;
